import React from 'react';
import Row from '@amzn/meridian/row';
import Input from '@amzn/meridian/input';

interface TableSearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const TableSearchBar: React.FC<TableSearchBarProps> = ({
  value,
  onChange,
  placeholder = 'Search by scancode or title...',
}) => (
  <Row spacingInset="300" alignmentVertical="center" backgroundColor="secondary">
    <Input
      value={value}
      onChange={onChange}
      type="text"
      placeholder={placeholder}
      aria-label="Search entries"
      size="medium"
      width={300}
    />
  </Row>
);

export default TableSearchBar;
